import { MailboxTypeEnum } from '../../constants';

export const locale = {
  [MailboxTypeEnum.Inbox]: 'Search inbox',
  [MailboxTypeEnum.Draft]: 'Search draft',
  [MailboxTypeEnum.Sent]: 'Search sent',
  [MailboxTypeEnum.Archive]: 'Search archive',
};
